import { render } from "./QuantSection.vue?vue&type=template&id=6db041c3&scoped=true"
import script from "./QuantSection.vue?vue&type=script&lang=js"
export * from "./QuantSection.vue?vue&type=script&lang=js"

import "./QuantSection.vue?vue&type=style&index=0&id=6db041c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db041c3"]])

export default __exports__